module.exports = __webpack_public_path__ + "static/media/orange_team.94f32377.svg";